import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    primary: { type: Boolean, required: false },
    secondary: { type: Boolean, required: false },
    tertiary: { type: Boolean, required: false },
    info: { type: Boolean, required: false },
    cancel: { type: Boolean, required: false },
    small: { type: Boolean, required: false },
    large: { type: Boolean, required: false },
    delete: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const _class = computed(()=>({
  "occ-btn-primary": props.primary,
  "occ-btn-secondary": props.secondary,
  "occ-btn-tertiary": props.tertiary,
  "occ-btn-info": props.info,
  "occ-btn-cancel": props.cancel,
  "occ-btn-delete": props.delete,
  "small": props.small,
  "large": props.large,
}));

const __returned__ = { props, _class }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})